import { onValue, ref as databaseRef } from "firebase/database";
import { defaultPricing, type PricingData } from "~/data/pricing";

const pricingState = () =>
  useState<PricingData>("pricing-data", () => defaultPricing);

const pricingLoadedState = () =>
  useState<boolean>("pricing-data-loaded", () => false);

const pricingSubscriptionState = () =>
  useState<boolean>("pricing-data-subscribed", () => false);

export const usePricing = () => {
  const pricing = pricingState();
  const loaded = pricingLoadedState();
  const subscribed = pricingSubscriptionState();

  if (process.client && !subscribed.value) {
    subscribed.value = true;
    const { $rtdb } = useNuxtApp() as any;

    if ($rtdb) {
      onValue(
        databaseRef($rtdb, "pricing"),
        (snapshot) => {
          const value = snapshot.val() as PricingData | null;
          if (value) {
            pricing.value = value;
          }
          loaded.value = true;
        },
        (error) => {
          console.warn("Unable to load pricing from Realtime Database", error);
          loaded.value = true;
        },
      );
    }
  }

  const servicePrice = (serviceId: string) =>
    computed(
      () =>
        pricing.value.services?.[serviceId]?.displayPrice ??
        defaultPricing.services[serviceId]?.displayPrice ??
        "$200 minimum",
    );

  const serviceLabel = (serviceId: string) =>
    computed(
      () =>
        pricing.value.services?.[serviceId]?.label ??
        defaultPricing.services[serviceId]?.label ??
        "Starting Price",
    );

  const loadPrice = (loadId: string) =>
    computed(
      () =>
        pricing.value.generalLoad.find((item) => item.id === loadId)?.price ??
        defaultPricing.generalLoad.find((item) => item.id === loadId)?.price ??
        "",
    );

  return {
    pricing,
    loaded,
    servicePrice,
    serviceLabel,
    loadPrice,
  };
};
